import { Box, Typography } from "@mui/material";
import TopicsPage from "./TopicsPage";
import "../../styles/common.css";
import { dateFromatter } from "../../utils/utils";

interface NotesSlideOverProps {
  isSlideOverOpen: boolean;
  note: {
    interactionId: string;
    interactionStartTime: string;
    overAllSentiment: string;
    sentiment: {
      sentimentSummary?: string | null;
    } | null;
    summary: string;
  };
}

const sentimentColors: Record<string, string> = {
  Positive: "#1EC96B",
  Neutral: "#F7B750",
  Negative: "#FF4D4D"
};

const sentimentLabels: Record<string, string> = {
  Positive: "Positive",
  Neutral: "Neutral",
  Negative: "Detractor",
};

const NotesSlideOver: React.FC<NotesSlideOverProps> = ({ note }) => {
    const displayLabel = sentimentLabels[note.overAllSentiment] || note.overAllSentiment;
  return (
    <Box className="p2p-slide-box">
        <Box className="p2p-slide-header-box">
            <Typography className="p2p-slide-header-text">
                <span className="date">{dateFromatter(note.interactionStartTime)}:</span>
                <span className="title">{note.summary}</span>
            </Typography>
            <Box display="flex" gap={1} alignItems="center" >
                <Box className="p2p-sentiment-dot"
                    sx={{bgcolor: sentimentColors[note.overAllSentiment]}}
                />
                <Typography variant="body2" className="p2p-sentiment-label">
                    {displayLabel}
                </Typography>
            </Box>
        </Box>
        <Box className="p2p-slide-container">
            <Typography className="p2p-slides-summary">
                <span className="head">Insights: </span>
                <span className="body">{note?.sentiment?.sentimentSummary || "No insight available"}</span>
            </Typography>

            <Typography className="p2p-slides-topic">
                Topics:
            </Typography>
            <Box className="topics-scroll">
              <TopicsPage interactionId={note.interactionId} />
            </Box>
        </Box>
    </Box>
  );
};

export default NotesSlideOver;
